import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
    'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                default: 'border-transparent bg-primary text-primary-foreground shadow-sm',
                secondary:
                    'border-transparent bg-gradient-to-r from-gray-100 to-gray-200 text-gray-900',
                destructive:
                    'border-transparent bg-gradient-to-r from-red-600 to-red-700 text-white shadow-sm',
                outline: 'text-gray-700 border-gray-200 bg-white/50 backdrop-blur-sm',
                success:
                    'border-transparent bg-gradient-to-r from-emerald-50 to-green-50 text-emerald-800 ring-1 ring-emerald-600/10',
                warning:
                    'border-transparent bg-gradient-to-r from-amber-50 to-yellow-50 text-amber-800 ring-1 ring-amber-600/10',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
);

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

// eslint-disable-next-line react-refresh/only-export-components
export { Badge, badgeVariants };
